var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['app', { '-ios': _vm.isIphoneOS }],attrs:{"id":"app"}},[_c('router-view',_vm._b({staticClass:"view"},'router-view',_vm.$props,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }